const badge = "_badge_ptcft_1";
const badgeIsSelected = "_badgeIsSelected_ptcft_26";
const badgeIsPressed = "_badgeIsPressed_ptcft_37";
const badgeIsDismissible = "_badgeIsDismissible_ptcft_43";
const badgeIsFocused = "_badgeIsFocused_ptcft_50";
const badgeText = "_badgeText_ptcft_55";
const styles = {
  badge,
  badgeIsSelected,
  badgeIsPressed,
  badgeIsDismissible,
  badgeIsFocused,
  badgeText
};
export {
  styles as s
};
